module.exports = __webpack_public_path__ + "img/mid-back-stretch-wfh-stretches.f8932157.jpg";